<template>
  <div id="app">
    <app-header></app-header>
    <router-view/>
    <app-footer></app-footer>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  name: 'App',
  components: {
      'app-footer': Footer,
      'app-header': Header
  }
}
</script>

<style lang="scss">
$openSans: 'Open Sans', Helvetica, Arial, sans-serif;

body {
    background: #F8F9FA; //#292929
    font-family: $openSans;
}
</style>



// WEBPACK FOOTER //
// src/App.vue